import { render, staticRenderFns } from "./tareasKanban.vue?vue&type=template&id=9fef0022&scoped=true&"
import script from "./tareasKanban.vue?vue&type=script&lang=ts&"
export * from "./tareasKanban.vue?vue&type=script&lang=ts&"
import style0 from "./tareasKanban.vue?vue&type=style&index=0&id=9fef0022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fef0022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDialog,VIcon,VSpacer,VTextField,VToolbar,VToolbarTitle})
